// import '~/js/modules/stickyNav';


/* eslint func-names: ["error", "never"] */

/* eslint-disable */

// import '~/js/sections/weddings/includes/stickyNav';
import '~/js/libs/jqueryEventMove';
import '~/js/libs/jqueryTwentytwenty';
import '~/js/sections/weddings/includes/scroll-below';

import inclusions from '~/js/sections/root/includes/inclusion-slides';

import 'slick-carousel';

const { countries } = beaches_app.page;


const preventMultiple = () => {
  let popup = document.querySelectorAll('.ntf-box');

  if (popup.length > 0) {
    popup = document.querySelector('.ntf-box');
    popup.parentNode.removeChild(popup);
  }

  const targetNode = document.querySelector('body');
  const observer = new MutationObserver((mutationsList) => {
    if (!mutationsList[0].target.classList.contains('has-modal')) {
      const popupBox = document.querySelector('.ntf-box');

      popupBox === null ? '' : popupBox.parentNode.removeChild(popupBox);
    }
  });

  observer.observe(targetNode, { attributes: true });
};

document.addEventListener('click', (e) => {
  const target = e.target;

  if (target.classList.contains('form-submit-button')) {
    preventMultiple();
  }
});

// Variable Declaration
const $carousel = $('#inc-carousel');
const $control = $('.inc-carousel-control');

// Initialization carousel
$carousel.slick({
  infinite: false,
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  arrows: false,
  prevArrow: '<button class="arrow arrow-prev1"></button>',
  nextArrow: '<button class="arrow arrow-next"></button>',
  responsive: [{
    breakpoint: 1024,
    settings: {
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
    }
  }]
});
